// extracted by mini-css-extract-plugin
export var attachment = "_qn-a";
export var emailContainer = "_qn-4";
export var emailContentPaddedContainer = "_qn-b";
export var emailHeader = "_qn-6";
export var emailIframe = "_qn-3";
export var emailInfoIcon = "_qn-9";
export var emailShortenedSummary = "_qn-e";
export var infoDropdown = "_qn-0";
export var infoRowBoundedContent = "_qn-d";
export var internal = "_qn-5";
export var merchant = "_qn-8";
export var messageInputContainer = "_qn-h";
export var normal = "_qn-7";
export var replyCard = "_qn-f";
export var subtleButton = "_qn-1";
export var subtleButtonIconContainer = "_qn-2";
export var toggleViewRepliesButton = "_qn-c";
export var wrappingText = "_qn-g";